module.exports = __webpack_public_path__ + "static/media/layer_5.b9de8bf0.png";